var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FilterBaseInput',{staticClass:"filter-base-input-number",attrs:{"prefix":_vm.prefix,"suffix":_vm.suffix}},[_c('InputNumber',{style:(_vm.style),attrs:{"value":_vm.value},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }